import {
  SET_ACCOUNT_EXECUTIVE,
  UNSET_ACCOUNT_EXECUTIVE,
} from '@/vuex/modules/accountExecutive/types/mutations';

import {
  DEFINE_ACCOUNT_EXECUTIVE,
  CLEAR_ACCOUNT_EXECUTIVE,
} from '@/vuex/modules/accountExecutive/types/actions';


export default {
  state: {
    accountExecutive: null,
  },
  getters: {
    accountExecutive: state => state.accountExecutive,
  },
  mutations: {
    [SET_ACCOUNT_EXECUTIVE](state, data) {
      state.accountExecutive = data;
      localStorage.accountExecutive = JSON.stringify(data);
    },
    [UNSET_ACCOUNT_EXECUTIVE](state) {
      state.accountExecutive = null;
      localStorage.removeItem('accountExecutive');
    },
  },
  actions: {
    [DEFINE_ACCOUNT_EXECUTIVE](context, payload) {
      context.commit(SET_ACCOUNT_EXECUTIVE, payload.accountExecutive);
    },
    [CLEAR_ACCOUNT_EXECUTIVE](context) {
      context.commit(UNSET_ACCOUNT_EXECUTIVE);
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/accountExecutive/index.js